// extracted by mini-css-extract-plugin
export default {"format-container":"AvailableFormats_format-container__pMG9t"};